import React from 'react';
import { Select } from 'tdesign-react';
import styles from './index.module.scss';
import { IOption } from '@/tpss/types';

interface VersionSelectProps {
  onChange: (version: { id: string; name: string }) => void;
  options: IOption[];
  title: string;
  visible: boolean;
  activeId: string;
}

const VersionSelect: React.FC<VersionSelectProps> = ({
  onChange,
  options,
  title,
  visible,
  activeId
}) => {
  // const [activeId, setActiveId] = useState('');
  // const [tabs, setTabs] = useState<IOption[]>([]);
  // const [productVersions, setProductVersions] = useState<IProductVersion[]>([]);
  // const { setCurrentProductVersion } = useContext(ProductDetailContext);

  // const getOptionData = async () => {
  //   if (options?.length) {
  //     setTabs(options || []);
  //     setActiveId(options[0].value);
  //     // setProductVersions(options);
  //     // setCurrentProductVersion(options[0]);
  //     onChange({
  //       id: options[0].value,
  //       name: options[0].label
  //     });
  //   }
  // };

  const onSelectChange = (value: any, context) => {
    // setActiveId(value);
    console.log('onSelectChange', value);
    onChange({ id: value, name: context.option.label });
    // setCurrentProductVersion(
    //   productVersions.find((version) => numToStr(version.ID) === value) ||
    //     ({} as any)
    // );
  };

  // useEffect(() => {
  //   getOptionData();
  // }, [options]);
  function getSelectedValue() {
    if (activeId !== '') {
      return activeId;
    }
    if (options && options.length > 0) {
      onChange({ id: options[0].value, name: options[0].label });
      return options[0].value;
    }
    return '';
  }
  return (
    <div
      className={styles.versionWrapper}
      style={{
        opacity: visible ? 1 : 0
      }}
    >
      <div className={styles.label}>{title}</div>
      <Select
        value={getSelectedValue()}
        onChange={onSelectChange}
        options={options}
        style={{ width: '200px' }}
        size="large"
        clearable={false}
      />
    </div>
  );
};

export default VersionSelect;
